import React, { ChangeEvent } from 'react';

import UiSearchInput from '../../../modules/ui/ui-search-input/ui-search-input';
import UiSelect from '../../../modules/ui/ui-select/ui-select';

import './order-detailed-filters.scss';

interface OrderDetailedFiltersProps {
  statuses: { label: string; value: string }[];
  onQueryChange: (query: string) => void;
  onStatusChange: (status: string) => void;
}

const OrderDetailedFilters: React.FC<OrderDetailedFiltersProps> = ({
  onQueryChange,
  statuses,
  onStatusChange,
}) => {
  const onQueryChangeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    onQueryChange(e.target.value);
  };

  return (
    <div className="order__filter">
      <div className="order__filter-search">
        <UiSearchInput
          placeholder="Поиск позиций"
          sm
          onChange={onQueryChangeHandler}
        />
      </div>
      <div className="order__filter-status">
        <UiSelect
          placeholder="Статус реализации"
          sm
          options={statuses}
          onChange={(val) => {
            if (!Array.isArray(val) && val) {
              onStatusChange(val.value);
            }
          }}
        />
      </div>
    </div>
  );
};

export default OrderDetailedFilters;
